/**
 *  RadioGroup script file
**/

export default {
  name: 'RadioGroup',
  mixins: [],
  components: {
  },
  props: {
    options: {
      type: Array
    },
    name: {
      type: String,
      default: 'radios'
    },
    model: {
      type: [String, Boolean, Number],
      default: ''
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedValue: this.model
    }
  },
  computed: {
    getClasses () {
      return {
        'vertical': this.vertical
      }
    }
  },
  methods: {
    onRadiosChange () {
      this.$emit('change', this.selectedValue)
    }
  },
  watch: {
    model (model) {
      this.selectedValue = model
    }
  }
}
